// Module
var code = "<div layout=\"row\" layout-align=\"start center\" class=\"full-height\"> <md-icon bringoz-id-generator=\"serviceChatButton\" permission permission-only=\"'chat.list'\" ui-sref=\"service.delivery.chat({ id: $ctrl.serviceId })\" ng-click=\"$event.stopPropagation()\" md-svg-icon=\"chat\" class=\"bringoz-icon\"> </md-icon> </div> ";
// Exports
export default code;